import type { FC } from 'react';

import { useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import type { HeaderProps } from 'types';

import { SwitchLocale } from '../../switch-locale';

const Header: FC<HeaderProps> = ({ children }) => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { t } = useTranslate();

  return (
    <header className="flex items-center justify-between mx-12 py-2 w-full">
      <div className="w-6 md:w-[200px]">
        {paymentData?.returnURL && (
          <a
            href={paymentData?.returnURL}
            className="flex items-center gap-2.5 text-xl md:left-0 w-full"
          >
            <div className="h-3.5 w-3.5 bg-arrow-left-bet-city md:h-4 md:w-4" />
            <div className="hidden md:block text-base text-white">{t('betCity.back')}</div>
          </a>
        )}
      </div>

      <div className="text-lg md:text-xl leading-7 font-medium flex-grow text-center text-white">
        {children}
      </div>
      <div className="w-6 md:hidden" />
      <div className="w-[200px] hidden md:block">
        <SwitchLocale />
      </div>
    </header>
  );
};

export { Header };
